var kebabCase = require('lodash.kebabcase');

module.exports = function (importName) {
  var name = kebabCase(importName).replace(/-/, '/');
  return "react-icons/lib/".concat(name);
};